import Paciente from "@/model/Paciente";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    ListarHql: async (pHql: string) => {
        const response = await httpClient.get(`/Relatorio/relatorio?hql=${pHql}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarSql: async (pSql: string) => {
        const response = await httpClient.get(`/Relatorio/relatorioSQL?sql=${pSql}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AcrescentarGenerator: async (pGenerator: string, pNumero: number) => {
        const response = await httpClient.get(`/Relatorio/generator?sequence=${pGenerator}&adicionar=${pNumero}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AlterarGenerator: async (pGenerator: string, pNumero: number) => {
        const response = await httpClient.get(`/Relatorio/Alterargenerator?sequence=${pGenerator}&adicionar=${pNumero}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});